import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';
import ManutencaoPopup from '../Manutencao/ManutencaoPopup';
import styles from './ManutencaoFrota.module.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import LoadingOverlay from '../../../components/LoadingOverlay/LoadingOverlay';

const Icon = ({ name }) => {
    const icons = {
        FiArrowLeft: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>,
        FiTruck: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>,
        FiTool: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94-7.94l-3.77 3.77a1 1 0 0 0 0 1.4zm-6.6 6.6a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94-7.94l-3.77 3.77a1 1 0 0 0 0 1.4z"></path></svg>,
        FiClock: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>,
        FiCheckCircle: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-8.62"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>,
        FiEdit: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>,
        FiChevronDown: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>,
        FiChevronUp: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>,
        FiArrowRight: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>,
        FiRotateCcw: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>,
        FiSearch: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>,
    };
    return icons[name] || null;
};

const DescriptionModal = ({ task, onClose, onSave }) => {
    const [description, setDescription] = useState(task.description || '');

    const handleSave = () => {
        onSave(task, description);
        onClose();
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>Descrição do Serviço</h2>
                    <button onClick={onClose} className={styles.modalCloseButton}>&times;</button>
                </div>
                <div className={styles.modalBodyDescription}>
                    <p>Adicione uma breve descrição para identificar o serviço rapidamente no quadro.</p>
                    <textarea
                        className={styles.modalTextarea}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Ex: Troca de pneu dianteiro"
                        rows={3}
                    />
                </div>
                <div className={styles.modalFooter}>
                    <button onClick={onClose} className={`${styles.modalButton} ${styles.cancelButton}`}>Cancelar</button>
                    <button onClick={handleSave} className={`${styles.modalButton} ${styles.saveButton}`}>Salvar</button>
                </div>
            </div>
        </div>
    );
};

const ManutencaoFrota = () => {
    const [tasks, setTasks] = useState({ 'to-do': [], 'in-progress': [], 'done': [] });
    const [vehicles, setVehicles] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [isVehiclesVisible, setIsVehiclesVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    
    const [isManutencaoPopupOpen, setIsManutencaoPopupOpen] = useState(false);
    const [selectedVehicleForPopup, setSelectedVehicleForPopup] = useState(null);
    
    const [isDescriptionModalOpen, setIsDescriptionModalOpen] = useState(false);
    const [editingTask, setEditingTask] = useState(null);

    const [dragOverColumn, setDragOverColumn] = useState(null);

    const fetchAndOrganizeVehicles = useCallback(async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_BASE_URL}/api/veiculos`, { headers: { 'Authorization': `Bearer ${token}` } });
            
            const available = [];
            const tasksByStatus = { 'to-do': [], 'in-progress': [], 'done': [] };

            response.data.forEach(vehicle => {
                const status = vehicle.status_manutencao;
                if (status && tasksByStatus[status]) {
                    tasksByStatus[status].push({
                        id: `task-${vehicle.id}`,
                        vehicle: vehicle,
                        title: 'Manutenção',
                        vehicleName: `${vehicle.marca} ${vehicle.modelo}`,
                        vehiclePlate: vehicle.placa,
                        description: vehicle.descricao_manutencao,
                    });
                } else {
                    available.push(vehicle);
                }
            });
            setVehicles(available);
            setTasks(tasksByStatus);
        } catch (err) {
            console.error("Erro ao buscar veículos:", err);
        }
    }, []);

    const filteredVehicles = useMemo(() => {
        return vehicles.filter(vehicle => {
            const searchStr = searchTerm.toLowerCase();
            return (
                vehicle.marca?.toLowerCase().includes(searchStr) ||
                vehicle.modelo?.toLowerCase().includes(searchStr) ||
                vehicle.placa?.toLowerCase().includes(searchStr)
            );
        });
    }, [vehicles, searchTerm]);

    useEffect(() => {
        const MIN_LOADING_TIME = 300;
        const startTime = Date.now();
        setPageLoading(true);

        const loadData = async () => {
            await fetchAndOrganizeVehicles();
            const endTime = Date.now();
            const duration = endTime - startTime;
            const remainingTime = MIN_LOADING_TIME - duration;
            if (remainingTime > 0) {
                setTimeout(() => setPageLoading(false), remainingTime);
            } else {
                setPageLoading(false);
            }
        };
        loadData();
    }, [fetchAndOrganizeVehicles]);
    
    const handleUpdateMaintenance = useCallback(async (vehicleId, payload) => {
        try {
            const token = localStorage.getItem('token');
            await axios.put(`${API_BASE_URL}/api/veiculos/${vehicleId}/manutencao`, payload, { headers: { 'Authorization': `Bearer ${token}` } });
        } catch (error) {
            console.error("Erro ao atualizar manutenção:", error);
            fetchAndOrganizeVehicles(); 
        }
    }, [fetchAndOrganizeVehicles]);

    const handleCardClick = (task) => {
        setSelectedVehicleForPopup(task.vehicle);
        setIsManutencaoPopupOpen(true);
    };

    const openDescriptionModal = (task, event) => {
        event.stopPropagation(); 
        setEditingTask(task);
        setIsDescriptionModalOpen(true);
    };

    const handleSaveDescription = (task, newDescription) => {
        setTasks(prevTasks => {
            const newTasks = { ...prevTasks };
            for (const status in newTasks) {
                newTasks[status] = newTasks[status].map(t =>
                    t.id === task.id ? { ...t, description: newDescription } : t
                );
            }
            return newTasks;
        });

        handleUpdateMaintenance(task.vehicle.id, {
            status: task.vehicle.status_manutencao,
            description: newDescription,
        });
    };

    const handleMove = (itemId, itemType, sourceColumnId, targetColumnId) => {
        if (itemType === 'vehicle' && targetColumnId === 'to-do') {
            const vehicleToMove = vehicles.find(v => String(v.id) === String(itemId));
            if (vehicleToMove) {
                const newTask = {
                    id: `task-${vehicleToMove.id}`,
                    vehicle: { ...vehicleToMove, status_manutencao: 'to-do' },
                    title: 'Manutenção',
                    vehicleName: `${vehicleToMove.marca} ${vehicleToMove.modelo}`,
                    vehiclePlate: vehicleToMove.placa,
                    description: vehicleToMove.descricao_manutencao, 
                };
                setVehicles(prev => prev.filter(v => v.id !== vehicleToMove.id));
                setTasks(prev => ({ ...prev, 'to-do': [...prev['to-do'], newTask] }));
                handleUpdateMaintenance(vehicleToMove.id, { status: 'to-do' });
            }
        } 
        else if (itemType === 'task' && sourceColumnId) {
            const taskToMove = tasks[sourceColumnId]?.find(t => t.id === itemId);
            if (taskToMove) {
                if (targetColumnId === 'disponivel') {
                    const vehicleData = taskToMove.vehicle;
                    setTasks(prev => ({...prev, [sourceColumnId]: prev[sourceColumnId].filter(t => t.id !== taskToMove.id)}));
                    setVehicles(prev => [...prev, {...vehicleData, status_manutencao: null, descricao_manutencao: null}]);
                    handleUpdateMaintenance(vehicleData.id, { status: null, description: null });
                } else {
                    const updatedTask = { ...taskToMove, vehicle: { ...taskToMove.vehicle, status_manutencao: targetColumnId }};
                    setTasks(prev => {
                        if (!prev[sourceColumnId] || !prev[targetColumnId]) return prev;
                        const newSourceTasks = prev[sourceColumnId].filter(t => t.id !== taskToMove.id);
                        const newDestTasks = [...prev[targetColumnId], updatedTask];
                        return { ...prev, [sourceColumnId]: newSourceTasks, [targetColumnId]: newDestTasks };
                    });
                    handleUpdateMaintenance(taskToMove.vehicle.id, { status: targetColumnId });
                }
            }
        }
    };
    
    const onDragStart = (e, item, itemType, sourceColumnId = null) => {
        e.dataTransfer.setData('itemId', itemType === 'vehicle' ? String(item.id) : item.id);
        e.dataTransfer.setData('itemType', itemType);
        if (sourceColumnId) e.dataTransfer.setData('sourceColumnId', sourceColumnId);
    };

    const onDrop = (e, targetColumnId) => {
        e.preventDefault();
        setDragOverColumn(null);
        const itemType = e.dataTransfer.getData('itemType');
        const itemId = e.dataTransfer.getData('itemId');
        const sourceColumnId = e.dataTransfer.getData('sourceColumnId');
        handleMove(itemId, itemType, sourceColumnId, targetColumnId);
    };

    return (
        <>
            <div className={styles.container}>
                {pageLoading && <LoadingOverlay text="Carregando quadro..." />}

                {!pageLoading && (
                    <>
                        <PageHeader 
                            title="Quadro de Manutenção"
                            subtitle="Clique nas setas ou arraste os cards para gerenciar o status da frota."
                            backTo="/sistema-frota"
                        />

                        <section className={styles.collapsibleSection}>
                            <button 
                                className={`${styles.collapsibleTrigger} ${isVehiclesVisible ? styles.active : ''}`}
                                onClick={() => setIsVehiclesVisible(!isVehiclesVisible)}
                            >
                                <div className={styles.triggerInfo}>
                                    <Icon name="FiTruck" />
                                    <span className={styles.triggerTitle}>Veículos Disponíveis</span>
                                    <span className={styles.countBadge}>{vehicles.length}</span>
                                </div>
                                <Icon name={isVehiclesVisible ? "FiChevronUp" : "FiChevronDown"} />
                            </button>

                            <div className={`${styles.collapsibleContent} ${isVehiclesVisible ? styles.show : ''}`}>
                                <div className={styles.searchContainer}>
                                    <div className={styles.searchInputWrapper}>
                                        <Icon name="FiSearch" />
                                        <input 
                                            type="text" 
                                            placeholder="Buscar por placa, marca ou modelo..." 
                                            className={styles.searchInput}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        {searchTerm && (
                                            <button className={styles.clearSearch} onClick={() => setSearchTerm('')}>&times;</button>
                                        )}
                                    </div>
                                </div>

                                <div className={styles.vehicleList}>
                                    {filteredVehicles.length === 0 ? (
                                        <p className={styles.emptyMessage}>
                                            {searchTerm ? 'Nenhum veículo encontrado para esta busca.' : 'Nenhum veículo disponível no momento.'}
                                        </p>
                                    ) : (
                                        filteredVehicles.map(vehicle => (
                                            <div key={vehicle.id} className={styles.vehicleCard} draggable onDragStart={(e) => onDragStart(e, vehicle, 'vehicle')}>
                                                <div className={styles.cardContent}>
                                                    <div className={styles.cardInfo}>
                                                        <span className={styles.cardTitle}>{vehicle.marca} {vehicle.modelo}</span>
                                                        <span className={styles.cardSubtitle}>{vehicle.placa || 'Sem Placa'}</span>
                                                    </div>
                                                    <button 
                                                        className={styles.quickMoveButton} 
                                                        onClick={() => handleMove(String(vehicle.id), 'vehicle', null, 'to-do')}
                                                        title="Mover para A Fazer"
                                                    >
                                                        <Icon name="FiArrowRight" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </section>
                        
                        <main className={styles.kanbanBoard}>
                            {Object.entries({ 'to-do': 'A Fazer', 'in-progress': 'Em Andamento', 'done': 'Concluído' }).map(([columnId, columnTitle]) => (
                                <section key={columnId} className={styles.kanbanColumn} onDrop={(e) => onDrop(e, columnId)} onDragOver={(e) => e.preventDefault()} onDragEnter={() => setDragOverColumn(columnId)} onDragLeave={() => setDragOverColumn(null)}>
                                    <header className={styles.columnHeader}>
                                        <Icon name={{'to-do': 'FiClock', 'in-progress': 'FiTool', 'done': 'FiCheckCircle'}[columnId]} />
                                        <h2 className={styles.columnTitle}>{columnTitle}</h2>
                                    </header>
                                    <div className={`${styles.taskList} ${dragOverColumn === columnId ? styles.dragOver : ''}`}>
                                        {(tasks[columnId] || []).map(task => (
                                            <article key={task.id} className={styles.taskCard} draggable onDragStart={(e) => onDragStart(e, task, 'task', columnId)}>
                                                <div className={styles.cardContent} onClick={() => handleCardClick(task)}>
                                                    <div className={styles.cardInfo}>
                                                        <div className={styles.cardHeader}>
                                                            <h3 className={styles.cardTitle}>{task.vehicleName}</h3>
                                                            <span className={styles.cardPlateBadge}>{task.vehiclePlate || 'Sem Placa'}</span>
                                                        </div>
                                                        <p className={`${styles.cardDescription} ${task.description ? styles.hasContent : ''}`}>
                                                            {task.description || 'Sem descrição...'}
                                                        </p>
                                                    </div>
                                                    <div className={styles.quickActionsContainer}>
                                                        <button className={styles.iconButton} onClick={(e) => openDescriptionModal(task, e)} title="Editar descrição">
                                                            <Icon name="FiEdit" />
                                                        </button>
                                                        
                                                        {columnId === 'to-do' && (
                                                            <button className={styles.quickMoveButton} onClick={(e) => { e.stopPropagation(); handleMove(task.id, 'task', 'to-do', 'in-progress'); }}>
                                                                <Icon name="FiArrowRight" />
                                                            </button>
                                                        )}
                                                        {columnId === 'in-progress' && (
                                                            <div className={styles.doubleActions}>
                                                                <button className={styles.quickMoveButton} onClick={(e) => { e.stopPropagation(); handleMove(task.id, 'task', 'in-progress', 'to-do'); }}>
                                                                    <Icon name="FiRotateCcw" />
                                                                </button>
                                                                <button className={styles.quickMoveButton} onClick={(e) => { e.stopPropagation(); handleMove(task.id, 'task', 'in-progress', 'done'); }}>
                                                                    <Icon name="FiArrowRight" />
                                                                </button>
                                                            </div>
                                                        )}
                                                        {columnId === 'done' && (
                                                            <button className={styles.quickMoveButton} onClick={(e) => { e.stopPropagation(); handleMove(task.id, 'task', 'done', 'disponivel'); }}>
                                                                <Icon name="FiRotateCcw" />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </article>
                                        ))}
                                    </div>
                                </section>
                            ))}
                        </main>
                    </>
                )}
            </div>

            {isManutencaoPopupOpen && (
                <ManutencaoPopup vehicle={selectedVehicleForPopup} onClose={() => setIsManutencaoPopupOpen(false)} />
            )}

            {isDescriptionModalOpen && editingTask && (
                <DescriptionModal 
                    task={editingTask}
                    onClose={() => setIsDescriptionModalOpen(false)}
                    onSave={handleSaveDescription}
                />
            )}
        </>
    );
};

export default ManutencaoFrota;